import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// 各個語系的 key（中文為繁體）
const localeKeys = ['en', 'zh-TW', 'ko', 'jp'];

// 各語系語言包
const messages = {};
for (const key of localeKeys) {
  const langObj = require(`./locales/${key}`).default;
  messages[key] = {
    ...langObj,
  };
}

let initialLocale = localStorage.getItem('change-language') || 'zh-TW';
if (initialLocale === 'zh-CN') {
  initialLocale = 'zh-TW';
  localStorage.setItem('change-language', 'zh-TW');
}

export default new VueI18n({
  locale: initialLocale,
  messages,
  silentTranslationWarn: true // 忽略翻譯警告
});
